import util from './util';

export function calculateProfitLoss(price: number, size: number | string, type: 'BACK' | 'LAY') {
	return util.numMultiply(util.numAdd(price, -1), Number(size)) * (type === 'BACK' ? 1 : -1);
}
